import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ChevronRight, ChevronLeft } from 'react-feather';
import { X } from 'react-feather/dist';
import Modal from 'react-modal';

const PhotoGalleryComponent = props => {
	const { isLoading, customContainerClassName, headingClassName } = props;

	const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(null);

	const toggleLightbox = index => {
		setSelectedIndex(index);
		setLightboxIsOpen(!lightboxIsOpen);
	};

	useEffect(() => {
		if (lightboxIsOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [lightboxIsOpen]);

	let galleryAll = props.gallery;
	if (props.gallery.length > 0) {
		galleryAll = props.gallery[0];
	}

	let items = galleryAll.photos.map(item => ({
		...item,
		id: item.id,
		caption: 'Bay Area Siding Company',
		src: item.fullSize.images.fallback && item.fullSize.images.fallback.src,
		w: 1200,
		h: 900,
		alt: item.title
	}));

	return (
		<div className="py-12 md:py-20 overflow-hidden bg-white">
			<div className="container mx-auto px-4 md:px-6 relative isolate">
				<svg
					className="absolute inset-x-0  top-[-30px] -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
					aria-hidden="true"
				>
					<defs>
						<pattern
							id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
							width={200}
							height={200}
							x="50%"
							y={-1}
							patternUnits="userSpaceOnUse"
						>
							<path d="M.5 200V.5H200" fill="none" />
						</pattern>
					</defs>
					<svg
						x="50%"
						y={-1}
						className="overflow-visible fill-gray-50"
					>
						<path
							d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
							strokeWidth={0}
						/>
					</svg>
					<rect
						width="100%"
						height="100%"
						strokeWidth={0}
						fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)"
					/>
				</svg>{' '}
				<h3 className="font-display text-2xl md:text-3xl font-bold text-center max-w-7xl mx-auto text-balance font-display text-gray-900">
					<span
						dangerouslySetInnerHTML={{
							__html: galleryAll.title
								? galleryAll.title
								: 'No Gallery Title'
						}}
					/>
				</h3>
				{galleryAll.description &&
				galleryAll.description.description ? (
					<p className="text-gray-700 text-center max-w-4xl mx-auto py-2 text-sm md:text-base">
						{galleryAll.description.description}
					</p>
				) : null}
				<div className="max-w-7xl px-4 md:-px-2 mx-auto flex flex-wrap justify-center mt-6">
					{items.map((item, index) => {
						return (
							<button
								onClick={() => toggleLightbox(index)}
								key={item.id}
								className="w-1/3 sm:w-1/4 lg:w-[13%] p-1 photo-mobile-view mobile-view"
							>
								<GatsbyImage
									image={getImage(item.fullSize)}
									className="lg:max-h-[82px] xl:max-h-[105px] md:max-h-[115px] thumbnail-img rounded-lg w-full shadow-xl aspect-square hover:scale-105 transform transition-all duration-300 ease-in-out"
									imgClassName="object-cover w-full h-full"
									style={{ cursor: 'pointer' }}
									alt={item.alt}
									loading="eager"
									quality={100}
									aspectRatio={1}
								/>
							</button>
						);
					})}
				</div>
				<p className=" text-center">
					<i className="font-[400] text-sm text-[#9ca3af]">
						Tap images to enlarge
					</i>
				</p>
				{lightboxIsOpen && (
					<Modal
						isOpen={lightboxIsOpen}
						onRequestClose={() => setLightboxIsOpen(false)}
						closeTimeoutMS={300}
						contentLabel="Get an Estimate"
						className="Modal bg-transparent bg-opacity-80 overflow-hidden"
						overlayClassName="Overlay"
					>
						<div
							className="relative w-screen h-screen flex items-center justify-center"
							onClick={e => e.stopPropagation()}
						>
							{/* Close Button */}
							<button
								className="absolute top-4 right-4 text-white rounded-full p-3 transition z-10"
								onClick={() => setLightboxIsOpen(false)}
							>
								<X />
							</button>

							{/* Carousel */}
							<Carousel
								selectedItem={selectedIndex}
								showIndicators={false}
								showThumbs={false}
								showStatus={false}
								infiniteLoop
								useKeyboardArrows
								autoPlay={false}
								transitionTime={500}
								className="w-full h-full flex items-center"
								onChange={index => setSelectedIndex(index)}
								renderArrowPrev={(
									onClickHandler,
									hasPrev,
									label
								) =>
									selectedIndex !== 0 && (
										<button
											type="button"
											onClick={onClickHandler}
											title={label}
											className="absolute left-6 top-1/2 transform -translate-y-1/2 z-10 
                      text-white rounded-full 
                      w-12 h-12 flex items-center justify-center 
                      hover:bg-gray-600 transition duration-300 shadow-lg"
											style={{
												backgroundColor:
													'rgba(255, 255, 255, 0.2)'
											}}
										>
											<ChevronLeft />
										</button>
									)
								}
								renderArrowNext={(
									onClickHandler,
									hasNext,
									label
								) =>
									selectedIndex !==
										galleryAll.photos.length - 1 && (
										<button
											type="button"
											onClick={onClickHandler}
											title={label}
											className="absolute right-6 top-1/2 transform -translate-y-1/2 z-10 
                         bg-opacity-50 text-white rounded-full  
                        w-12 h-12 flex items-center justify-center 
                        hover:bg-gray-600 transition duration-300 shadow-lg"
											style={{
												backgroundColor:
													'rgba(255, 255, 255, 0.2)'
											}}
										>
											<ChevronRight />
										</button>
									)
								}
							>
								{galleryAll.photos.map((photo, index) => {
									return (
										<div
											key={photo.id}
											className={`h-full GatsbyImage flex justify-center items-center carousel-container carousel-height"
                      : ""
                  } `}
										>
											<GatsbyImage
												image={getImage(photo.fullSize)}
												alt={
													photo.title ||
													'Gallery Image'
												}
												className="object-contain w-full h-full"
											/>
										</div>
									);
								})}
							</Carousel>

							<div className="absolute bottom-4 left-6 text-white z-10">
								<p className="text-xs">
									Bay Area Siding Company
								</p>
							</div>
							<div className="absolute bottom-4 right-6 text-white z-10">
								<p className="text-xs">
									{selectedIndex + 1} of{' '}
									{galleryAll.photos.length}
								</p>
							</div>
						</div>
					</Modal>
				)}
			</div>
		</div>
	);
};

export default PhotoGalleryComponent;
